module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_photowedding@3x-b1abd84cf22661878a49661399c26691.webp";